import { ConfigurationDetailPanel } from '~/features/integrations/ConfigurationDetailPanel/ConfigurationDetailPanel';
import { SyncPairConfig } from '~/features/integrations/ConfigurationDetailPanel/types';
import { api } from '~/redux/api/createApi';

interface Props {
  config: SyncPairConfig;
  tab: string;
  onHide: () => void;
}

export const AribaConfigPanel = (configPanelProps: Props) => {
  const { config } = configPanelProps;
  const { data: errors, isLoading } =
    api.endpoints.getSyncPairsAribaFailures.useQuery({
      syncPair: config.id,
    });

  return (
    <ConfigurationDetailPanel
      {...configPanelProps}
      errors={errors}
      isLoading={isLoading}
    />
  );
};
